<template>
  <div class="c-filter c_h_1">
    <div>
      <el-collapse v-model="activeCollapse">
        <el-collapse-item title="所有保存的过滤器" name="1">
          <div
            v-for="(item, i) in filterList"
            :key="i"
            @click="toQuery(item)"
            class="filter-list-item c_pointer"
            :class="activeId == item._id ? 'active' : ''"
            :title="item.name"
          >
            <span>{{ item.name }}</span>
          </div>
          <div class="filter-list-item c_pointer c_flex" v-if="filterList.length > 0">
            <div
              class="c_blue c_flex c_flex_between c_flex_center c_w"
              @click="$router.push({ path: `/filters?name=${name}` })"
            >
              <span>管理已保存的过滤器</span>
              <i class="el-icon-s-tools" style="color: #409eff"></i>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-if="defaultFilterShow" style="padding: 0 15px; height: 50px; line-height: 50px">
        <div
          class="c_blue c_flex c_flex_between c_flex_center c_w c_pointer"
          @click="addFilterClick"
        >
          <span>添加过滤器</span>
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
    <!--过滤字段搜索列表-->
    <div v-if="filterSearchShow" class="c_p_10 c_p_t_0 c_h_1">
      <div class="c_blue c_pointer" style="height: 50px; line-height: 50px" @click="toDefault()">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <el-input
        placeholder="快速查询筛选字段"
        v-model="addFilterSearch"
        clearable
        size="mini"
      ></el-input>
      <ul>
        <li
          class="c_b_r c_p_10 c_pointer c_h_blue_light c_li"
          v-for="(filter, i) in addFilterList"
          :key="i"
          @click="editFilter(filter)"
          v-if="
            filter.type != 'file' &&
              filter.type != 'title' &&
              filter.type != 'gap' &&
              filter.type != 'scan' &&
              filter.type != 'button' &&
              filter.type != 'image' &&
              filter.name.indexOf('orphanId') == -1
          "
        >
          {{ filter.nameDisp }}
        </li>
      </ul>
    </div>
    <!--编辑过滤器列表-->
    <div v-if="editFilterShow" class="c_p_10 c_p_t_0 c_p_b_0">
      <div
        class="c_blue c_pointer"
        style="height: 50px; line-height: 50px"
        @click="toFilterSearch()"
      >
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="c_p_10 c_p_t_0">
        <div style="margin: 0 0 10px">
          {{ selFilter.nameDisp }}
        </div>
        <!--时间字段-->
        <el-radio-group
          v-model="selDate"
          v-if="selFilter.type == 'date' || selFilter.type == 'datetime'"
        >
          <!-- <el-radio :label="0" class="c_p_10 c_p_b_0">
            <span class="c_size_12">指定日期</span>
            <div class="block c_m_t_n" v-if="selDate == 0">
              <el-date-picker
                type="date"
                v-model="filterDateTime.days"
                placeholder="请选择日期"
                value-format="yyyy-MM-dd"
                size="mini"
              ></el-date-picker>
            </div>
          </el-radio> -->
          <br />
          <!-- <el-radio :label="1" class="c_p_10 c_p_b_0">
            <span class="c_size_12">在此之前</span>
            <div class="block c_m_t_n" v-if="selDate == 1">
              <el-date-picker
                v-model="filterDateTime.before"
                :type="selFilter.type"
                placeholder="选择日期时间"
                :value-format="selFilter.type == 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
                default-time="00:00:00"
                size="mini"
              ></el-date-picker>
            </div>
          </el-radio> -->
          <br />
          <!-- <el-radio :label="2" class="c_p_10 c_p_b_0">
            <span class="c_size_12">在此之后</span>
            <div class="block c_m_t_n" v-if="selDate == 2">
              <el-date-picker
                v-model="filterDateTime.after"
                :type="selFilter.type"
                placeholder="选择日期时间"
                :value-format="selFilter.type == 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
                default-time="00:00:00"
                size="mini"
              ></el-date-picker>
            </div>
          </el-radio> -->
          <br />
          <div class="c_p_10 c_p_b_0">
            <!-- <el-radio :label="3" class="c_p_10 c_p_b_0"> -->
            <!-- <span class="c_size_12">在...之间</span> -->
            <div class="block c_m_t_n" style="padding-bottom: 15px" v-if="selDate == 3">
              <el-popover placement="right" width="400" trigger="click">
                <el-date-picker
                  style="width: 400px !important"
                  v-model="filterDateTime.between"
                  :type="selFilter.type + 'range'"
                  :picker-options="date.pickerOptions"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  align="right"
                  :value-format="
                    selFilter.type == 'datetime' ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'
                  "
                  size="mini"
                ></el-date-picker>
                <el-button slot="reference">选择时间</el-button>
              </el-popover>
            </div>
            <!-- </el-radio> -->
          </div>
        </el-radio-group>

        <!--字符串字段-->
        <template
          v-if="
            (selFilter.type == 'text' && selFilter.name != 'orgId') ||
              selFilter.type == 'textarea' ||
              selFilter.type == 'number' ||
              selFilter.type == 'phone' ||
              selFilter.type == 'IDNumber' ||
              selFilter.type == 'rate' ||
              selFilter.type == 'switch' ||
              selFilter.type == 'digit' ||
              selFilter.type == 'stepper'
          "
        >
          <el-radio-group v-model="isHas">
            <el-radio
              v-for="(item, i) in options.conditions"
              :key="i"
              :label="item.value"
              class="c_p_10"
              v-show="isSave || item.value == 'regex'"
            >
              <span class="c_size_12">{{ item.label }}</span>
            </el-radio>
          </el-radio-group>
          <el-input
            class="c_m_t_n c_m_b_n"
            placeholder="请输入内容"
            v-model="filterWords"
            clearable
            size="mini"
          ></el-input>
        </template>
        <!--选项字段-->
        <template v-if="selFilter.type == 'radio'">
          <el-radio-group v-model="filterWords">
            <el-radio
              v-for="(item, i) in options[selFilter.valueOption]"
              :key="i"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </template>
        <template v-if="selFilter.type == 'checkbox'">
          <el-checkbox-group v-model="filterWords" @change="$forceUpdate()">
            <el-checkbox
              v-for="(item, i) in options[selFilter.valueOption]"
              :key="i"
              :label="item.value"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </template>
        <template v-if="selFilter.type == 'select'">
          <el-select v-model="filterWords" placeholder="请选择" clearable filterable>
            <el-option
              v-for="(item, i) in options[selFilter.valueOption]"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-if="selFilter.type == 'bizSelect'">
          <el-select v-model="filterWords" placeholder="请选择" clearable filterable>
            <el-option
              v-for="(item, i) in options[selFilter.valueOption]"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <!--省市区字段-->
        <template v-if="selFilter.type == 'area'">
          <el-cascader
            :options="area.options"
            :props="area.props"
            v-model="filterWords"
            collapse-tags
            clearable
          ></el-cascader>
        </template>
        <!--级联-->
        <template v-if="selFilter.type == 'cascade'">
          <el-cascader
            v-model="filterWords"
            :options="options[selFilter.valueOption]"
            :props="{ checkStrictly: true, label: 'name' }"
            clearable
          ></el-cascader>
        </template>
        <!--所属组织-->
        <template v-if="selFilter.name == 'orgId'">
          <el-cascader
            ref="org"
            v-model="filterWords"
            :options="options.orgList"
            :show-all-levels="false"
            :props="{
              multiple: true,
              checkStrictly: true,
              emitPath: false,
              label: 'orgName',
              value: '_id',
              children: 'orgList'
            }"
            @change="getOrgCheckedNodes"
            clearable
            filterable
          ></el-cascader>
        </template>
      </div>

      <!--只要有一个选项有值就不禁用应用过滤器按钮-->
      <el-button
        v-if="!selFilter.isEdit"
        type="primary"
        class="c_flex c_m_n"
        :disabled="
          !filterWords &&
            !filterDateTime.days &&
            !filterDateTime.before &&
            !filterDateTime.after &&
            !filterDateTime.between
        "
        @click="filterApply(selFilter)"
      >
        应用过滤条件
      </el-button>
      <el-button
        v-else
        type="primary"
        class="c_flex c_m_n"
        :disabled="
          !filterWords &&
            !filterDateTime.days &&
            !filterDateTime.before &&
            !filterDateTime.after &&
            !filterDateTime.between
        "
        @click="updatePreFilter()"
      >
        更新过滤器
      </el-button>
    </div>
    <!--已应用过滤条件列表-->
    <div v-if="filterApplyShow">
      <h5 style="height: 50px; line-height: 50px; padding: 0 10px">已应用的过滤条件</h5>
      <ul>
        <li
          v-for="(item, index) in preFilter"
          :key="index"
          class="c_flex c_flex_between c_m_n bg_blue_light c_item_center c_li"
          style="border: 1px solid rgb(203, 214, 226); border-radius: 2px; padding: 5px 10px"
        >
          <span>{{ item.note }}</span>
          <!--          <span @click="toEditFilter(item, index)" class=" c_pointer">{{-->
          <!--            item.note-->
          <!--          }}</span>-->
          <i class="el-icon-close c_pointer" @click="delPreFilter(index)"></i>
        </li>
      </ul>
      <el-button type="text" class="c_p_10" icon="el-icon-plus" @click="addFilterClick('append')">
        <!-- v-if="isSave" -->
        添加过滤条件
        <span v-if="!isSave">（该报表仅支持单条件过滤）</span>
      </el-button>
      <!-- v-if="isSave" -->
      <div class="c_flex c_flex_around c_p_10">
        <el-button
          v-if="!sessionFilters && isSave"
          type="primary"
          style="min-width: 40%"
          @click="filterSaveClick()"
          :disabled="preFilterChange ? true : false"
        >
          保存
        </el-button>
        <el-button
          v-else-if="isSave"
          type="primary"
          style="min-width: 40"
          @click="filterSaveClick('update')"
        >
          更新
        </el-button>
        <el-button style="min-width: 40%" @click="cancelFilter()">取消</el-button>
      </div>
    </div>
    <!--弹窗:填写过滤器名称,并选择使用权限-->
    <el-dialog title="保存过滤器" class="c_flex_center" :visible.sync="filterSaveShow">
      <el-form>
        <el-form-item label="过滤器名称：">
          <el-input
            style="max-width: 55%; min-width: 50%"
            v-model="filterName"
            placeholder="请填写过滤器名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="可使用人群：">
          <el-radio-group v-model="filterUser">
            <el-radio :label="0">私人</el-radio>
            <!--<el-radio :label="1">团队</el-radio>-->
            <!-- <el-radio :label="1">所有人</el-radio> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="filterSave" :disabled="filterName ? false : true">
          确 定
        </el-button>
        <el-button @click="filterSaveShow = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../resources/js/area';
export default {
  activated() {
    window.$that = this;
  },
  name: 'c-filter',
  props: {
    colName: {
      //请求扩展动态表名
      type: String
    },
    filterThat: {
      //过滤器需要更新的组件this
      type: Object
    },
    isSave: {
      //过滤器需要更新的组件this
      type: Boolean,
      default: true
    }
  },
  activated() {
    window.$this = this;
    window.$that = this;
  },
  data() {
    return {
      userId: '',
      activeCollapse: '1', //已保存的过滤器-折叠面板
      activeId: '', //当前激活的菜单(过滤器)
      filterList: [], //已保存的过滤器列表
      name: '',
      //过滤器
      defaultFilterShow: true, //是否显示默认过滤器列表
      filterSearchShow: false, //是否显示过滤字段搜索列表
      addFilterSearch: '', //所有字段快速搜索关键词
      addFilterList0: [], //所有请求到的过滤条件
      addFilterList: [], //watch后的过滤条件
      selFilter: {
        //选中的要过滤的字段
        nameDisp: '',
        type: '',
        fieldName: '',
        editFilter: [],
        editIndex: null,
        isEdit: false
      },
      editFilterShow: false, //是否显示编辑过滤器列表
      isHas: 'regex',
      selDate: 3, //指定日期0、之前1、之后2、之间3
      filterField: '', //要过滤的字段名称
      filterWords: '', //是否包含的关键词
      preFilter: [], //所有预保存(临时应用)的过滤条件数组
      preFilterChange: true, //当preFilter更改时,保存按钮可用,当过滤器保存后,保存按钮不可用
      apply: '', //当点击添加过滤器时会清空filterWords,清空不触发watch,避免传空value
      filterApplyShow: false, //是否显示预保留过滤器列表
      filterSaveShow: false, //是否显示过滤器保存弹窗
      filterName: '', //过滤器名称
      filterUser: 0, //过滤器使用权限 个人、所有人
      filterDateTime: {
        //时间类型筛选
        days: '',
        before: '',
        after: '',
        between: ''
      },
      //所以过滤条件的json数组,保存过滤器时用到
      plans: [],
      //是否从session中获取了过滤条件
      sessionFilters: false,
      sessionPreFilters: false,
      filter: {
        name: '',
        _id: '',
        plans: []
      },
      activeFilter: '',
      //地址级联
      area: {
        props: {
          checkStrictly: true
        },
        options: this.osg.areaList
      },
      options: {
        conditions: [
          { label: '包含', value: 'regex' },
          { label: '等于', value: 'is' },
          { label: '不等于', value: 'ne' }
          // { label: "包含某个值或数组", value: "all" },
          // { label: "除此数组之外", value: "nin" },
          // { label: "在此数组之内", value: "in" }
        ],
        orgList: [], //级联
        orgs: []
      },
      that: null,
      orgNames: '' // 服务商名称返显
    };
  },
  mounted() {
    window.$that = this;
    //用于报表，解析报表里的colName
    if (this.colName && this.$util.isJson(this.colName) && JSON.parse(this.colName).colName) {
      this.name = JSON.parse(this.colName).colName;
    }
    this.that = this.filterThat || $this;
    this.name = this.name || $this.name; // 路由
    this.userId = sessionStorage['loginAccount']
      ? JSON.parse(sessionStorage['loginAccount'])._id
      : '';
    this.getFilterList();
  },

  methods: {
    // 获取已保存的过滤列表
    getFilterList() {
      this.osg.ajax(
        'queryPlan/query.do',
        {
          'is:tablename|string#and': this.name,
          'is:type|string#and': 'persion',
          'is:createUser|string#or': this.userId
        },
        res => {
          this.filterList = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 点击已保存的过滤器
    toQuery(filterObj) {
      sessionStorage.removeItem('filter');
      sessionStorage.removeItem('preFilter');
      sessionStorage['filter'] = JSON.stringify(filterObj);
      this.activeId = filterObj._id; //当前点击过滤器id
      $that.sessionFilters = false;
      this.that.getData();
    },
    // 点击添加过滤器
    addFilterClick(append) {
      console.log('thisname', this.name);

      if (append == 'append') {
        //如果已经有过滤条件了
        this.addFilterSearch = ''; //清空字段搜索
      }
      this.defaultFilterShow = false; //隐藏默认过滤器列表
      this.filterSearchShow = true; //显示过滤字段搜索列表
      this.filterApplyShow = false; //隐藏预保留过滤器列表
      // var $that = this;
      //请求所有的字段
      this.osg.ajax(
        `biz/ext/queryByColName/${this.name}.do`,
        {
          'is:state|integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
          //   'is:showList|array#and': 5//不是分页不好使
        },
        res => {
          $that.addFilterList0 = res.entity.extFieldList.filter(
            item => item.showList && item.showList.includes('5')
          );
          //扩展字段前面加exts.
          for (var item of $that.addFilterList0) {
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            // 根据字段属性的preset来判断是否是系统预置，1：系统预置，0：租户扩展
            if (item.preset == 0) {
              item.name = 'exts.' + item.name;
            }
          }
          $that.addFilterList = [].concat($that.addFilterList0);
        }
      );
    },
    // 返回默认列表
    toDefault() {
      this.filterSearchShow = false; //隐藏过滤字段搜索列表
      this.addFilterSearch = ''; //清空筛选字段搜索词
      if (this.preFilter.length > 0) {
        this.filterApplyShow = true; //显示/返回到已应用列表
      } else {
        this.defaultFilterShow = true; //显示默认列表
      }
    },
    // 点击字段名编辑过滤器
    editFilter(selFilter) {
      if (selFilter.valueOption && selFilter.type != 'bizSelect') {
        if (
          !this.that.options[selFilter.valueOption] ||
          this.that.options[selFilter.valueOption].length == 0
        ) {
          if (selFilter.type == 'cascade') {
            this.that.options['cascadeCode_' + selFilter.valueOption] = {
              codeId: selFilter.valueOption
            };
          } else {
            this.that.options['codecfg_' + selFilter.valueOption] = {
              codeId: selFilter.valueOption
            };
          }
          this.osg.codeoption(() => {
            this.isHas = 'is';
            this.options = Object.assign(this.options, this.that.options);
            this.filterSearchShow = false; //隐藏过滤字段搜索列表
            this.editFilterShow = true; //显示编辑过滤器列表
            if (selFilter.type == 'checkbox') {
              this.filterWords = [];
            } else {
              this.filterWords = '';
            }
            this.selFilter = selFilter;
          });
        } else {
          this.isHas = 'is';
          this.options = Object.assign(this.options, this.that.options);
          this.filterSearchShow = false; //隐藏过滤字段搜索列表
          if (selFilter.type == 'checkbox') {
            this.filterWords = [];
          } else {
            this.filterWords = '';
          }
          this.selFilter = selFilter;
          this.editFilterShow = true; //显示编辑过滤器列表
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      } else {
        this.options = Object.assign(this.options, this.that.options);
        this.filterSearchShow = false; //隐藏过滤字段搜索列表
        this.editFilterShow = true; //显示编辑过滤器列表
        if (selFilter.type == 'checkbox') {
          this.filterWords = [];
        } else {
          this.filterWords = '';
        }
        this.selFilter = selFilter;
      }
      if (selFilter.name == 'orgId') {
        this.getOrgList();
        this.getOrgs();
      }
    },
    // 返回搜索列表
    toFilterSearch() {
      if (this.selFilter.isEdit) {
        //是编辑状态/不是新建状态
        this.preFilter.splice(this.selFilter.editIndex, 0, this.selFilter.editFilter); //点击返回将编辑的放回原数组
        this.editFilterShow = false; //隐藏编辑过滤器列表
        this.filterApplyShow = true; //显示应用列表
        this.selFilter.isEdit = false;
        this.that.getData();
      } else {
        this.editFilterShow = false; //隐藏编辑过滤器列表
        this.filterSearchShow = true; //显示过滤字段搜索列表
        this.filterWords = ''; //清空包含/不含关键词
        this.filterDateTime = {
          //清空时间
          days: '',
          before: '',
          after: '',
          between: ''
        };
      }
    },
    // 点击应用过滤器-预保存过滤条件-并调用筛选
    filterApply(selFilter) {
      this.filterSearchShow = false; //隐藏过滤字段搜索列表
      this.editFilterShow = false; //隐藏编辑过滤器列表
      this.filterApplyShow = true; //显示预保留过滤器列表
      //判断类型
      if (selFilter.type == 'area') {
        this.filterWords = this.filterWords || [];
        let valueLabel;
        if (this.filterWords.length > 0) {
          for (var province of this.area.options) {
            if (province.value == this.filterWords[0]) {
              valueLabel = province.label;
              if (this.filterWords.length > 1) {
                for (var city of province.children) {
                  if (city.value == this.filterWords[1]) {
                    valueLabel += '/' + city.label;
                    if (this.filterWords.length > 2) {
                      for (var district of city.children) {
                        if (district.value == this.filterWords[2]) {
                          valueLabel += '/' + district.label;
                          break;
                        }
                      }
                    }
                    break;
                  }
                }
              }
              break;
            }
          }
        }

        //拼接过滤条件中文名称
        var preFilterName = this.selFilter.nameDisp + ' 属于 ' + valueLabel;

        //放入到已应用过滤条件数组
        this.preFilter.push({
          note: preFilterName,
          type: this.selFilter.type,
          fieldName: this.selFilter.name,
          relation: this.isHas,
          value: this.filterWords,
          field: this.selFilter
        });
      } else if (selFilter.type != 'date' && selFilter.type != 'datetime') {
        let conditionName;
        for (var condition of this.options.conditions) {
          if (condition.value == this.isHas) {
            conditionName = condition.label;
            break;
          }
        }

        let valueLabel;
        if (this.selFilter.type == 'cascade') {
          this.filterWords = this.filterWords || [];
          let str = '';
          let opts = this.that.$util.deepCopy(this.options[selFilter.valueOption]);
          // 单选级联 有几级循环几次
          for (var i = 0; i < this.filterWords.length; i++) {
            for (var opt of opts) {
              if (opt.value == this.filterWords[i]) {
                str += (opt.label || opt.name) + '/';
                opts = this.that.$util.deepCopy(opt.children);
                break;
              }
            }
          }
          str.slice(0, str.length - 2);
          valueLabel = str;
          // 渲染组织
        } else if (this.selFilter.name == 'orgId') {
          this.filterWords = this.filterWords || [];
          // let str = '';
          // let opts = this.that.$util.deepCopy(this.options.orgs);
          // for (let i = 0; i < this.filterWords.length; i++) {
          //   for (let opt of opts) {
          //     if (opt.value == this.filterWords[i]) {
          //       str += opt.label + '/';
          //       break;
          //     }
          //   }
          // }
          // str.slice(0, str.length - 2);
          valueLabel = this.orgNames;
        } else {
          if (this.selFilter.valueOption) {
            for (var item of this.options[selFilter.valueOption]) {
              if (item.value == this.filterWords) {
                valueLabel = item.label;
                break;
              }
            }
          } else {
            valueLabel = this.filterWords;
          }
        }
        //拼接过滤条件中文名称
        var preFilterName = this.selFilter.nameDisp + ' ' + conditionName + ' ' + valueLabel;

        //放入到已应用过滤条件数组
        this.preFilter.push({
          note: preFilterName,
          type: this.selFilter.type,
          fieldName: this.selFilter.name,
          relation: this.isHas,
          value: this.filterWords,
          field: this.selFilter
        });
      } else if (selFilter.type == 'date' || selFilter.type == 'datetime') {
        switch (this.selDate) {
          case 0:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.days + " 00:00:00'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.days, //+ " 00:00:00"
              field: this.selFilter
            });
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.days + " 23:59:59'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.days + ' 23:59:59',
              field: this.selFilter
            });
            break;
          case 1:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.before + "'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.before + '',
              field: this.selFilter
            });
            break;
          case 2:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.after + "'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.after + '',
              field: this.selFilter
            });
            break;
          case 3:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.between[0] + "'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.between[0] + '',
              field: this.selFilter
            });
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.between[1] + "'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.between[1] + '',
              field: this.selFilter
            });
            break;
          default:
        }
      }
      var obj = {};
      obj.key = this.name;
      obj.value = JSON.stringify(this.preFilter);
      sessionStorage['preFilter'] = JSON.stringify(obj);
      this.that.getData();
      this.apply = 'apply'; //当点击添加过滤器时会清空filterWords,清空不触发watch,避免传空value
      this.filterWords = ''; //清空包含/不含关键词
      this.filterDateTime = {
        //清空时间
        days: '',
        before: '',
        after: '',
        between: ''
      };
      this.isHas = 'is'; //设置默认为包含
      this.selDate = 3; //设置默认为指定某天
      this.activeFilter = 'other';
    },
    toEditFilter(item, index) {
      //点击应用的过滤器列表 编辑此过滤器
      this.preFilter.splice(index, 1);
      if (item.type != 'date' && item.type != 'datetime') {
        var nameDisp;
        if (item.relation == 'regex') {
          this.isHas = 'regex';
          nameDisp = item.note.split('包含')[0]; //包含前面的就是筛选字段名称，
        } else if (item.relation == 'ne') {
          this.isHas = 'ne';
          nameDisp = item.note.split('不是')[0]; //不是前面的就是筛选字段名称，
        }
        if (nameDisp) {
          nameDisp = nameDisp.substring(0, nameDisp.length - 1); //删除最后一个空格
        }
        this.filterWords = item.value;
      } else if (item.type == 'date' || item.type == 'datetime') {
        nameDisp = item.note.split('在')[0];
        if (item.relation == 'gte') {
          this.selDate = 2;
        } else if (item.relation == 'lte') {
          this.selDate = 1;
        }
        // this.filterWords = item.value.split(".")[0];
      }
      this.selFilter = {
        nameDisp: nameDisp,
        type: item.type,
        name: item.fieldName,
        editIndex: index,
        editFilter: item, //备份编辑的数据, 供返回恢复
        isEdit: true,
        field: item.field
      };
      this.filterApplyShow = false;
      this.editFilterShow = true;
    },
    //更新修改的过滤器
    updatePreFilter() {
      if (this.selFilter.type != 'date' && this.selFilter.type != 'datetime') {
        if (this.isHas == 1) {
          var preFilterName = this.selFilter.nameDisp + ' 包含 ' + "'" + this.filterWords + "'";
          var relation = 'regex';
        } else if (this.isHas == 0) {
          var preFilterName = this.selFilter.nameDisp + ' 不是 ' + "'" + this.filterWords + "'";
          var relation = 'ne';
        }
        var filter = {
          note: preFilterName,
          type: this.selFilter.type,
          fieldName: this.selFilter.name,
          relation: relation,
          value: this.filterWords
        };
        this.preFilter.splice(this.selFilter.editIndex, 0, filter);
      } else {
        switch (this.selDate) {
          case 0:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.days + " 00:00:00'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.days, //+ " 00:00:00"
              field: this.selFilter
            });
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.days + " 23:59:59'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.days + ' 23:59:59',
              field: this.selFilter
            });
            break;
          case 1:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.before + "'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.before + '',
              field: this.selFilter
            });
            break;
          case 2:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.after + "'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.after + '',
              field: this.selFilter
            });
            break;
          case 3:
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.between[0] + "'" + ' 之后';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'gte',
              value: this.filterDateTime.between[0] + '',
              field: this.selFilter
            });
            var preFilterName =
              this.selFilter.nameDisp + " 在 '" + this.filterDateTime.between[1] + "'" + ' 之前';
            this.preFilter.push({
              note: preFilterName,
              type: this.selFilter.type,
              fieldName: this.selFilter.name,
              relation: 'lte',
              value: this.filterDateTime.between[1] + '',
              field: this.selFilter
            });
            // $this.filters.push({
            //   filterKey:`gte:${this.selFilter.name}|string#and`,
            //   filterValue:this.filterDateTime.between[0] + ","
            // })
            // $this.filters.push({
            //   filterKey:`lte:${this.selFilter.name}|string#and`,
            //   filterValue:this.filterDateTime.between[1] + ""
            // })
            break;
          default:
        }
      }
      //跟新缓存
      var obj = {};
      obj.key = this.name;
      obj.value = JSON.stringify(this.preFilter);
      sessionStorage['preFilter'] = JSON.stringify(obj);
      this.filterSearchShow = false; //隐藏过滤字段搜索列表
      this.editFilterShow = false; //隐藏编辑过滤器列表
      this.filterApplyShow = true; //显示预保留过滤器列表
      this.that.getData();
      this.apply = 'apply'; //当点击添加过滤器时会清空filterWords,清空不触发watch,避免传空value
      this.filterWords = ''; //清空包含/不含关键词
      this.filterDateTime = {
        //清空时间
        days: '',
        before: '',
        after: '',
        between: ''
      };
      this.isHas = 'regex'; //设置默认为包含
      this.selDate = 3; //设置默认为指定某天
      this.selFilter.isEdit = false; //取消编辑模式
    },
    // 点击删除预保存的过滤条件
    delPreFilter(index) {
      event.stopPropagation();
      this.preFilter.splice(index, 1);
      if (this.preFilter.length < 1) {
        this.filterApplyShow = false; //隐藏预保留过滤器列表
        this.defaultFilterShow = true; //显示默认过滤列表
        window.sessionStorage.removeItem('filter'); //如果将过滤条件都删除, 不对以保存过滤器做任何操作
        window.sessionStorage.removeItem('preFilter');
        this.activeId = '';
      } else {
        var obj = {};
        obj.key = this.name;
        obj.value = JSON.stringify(this.preFilter);
        sessionStorage['preFilter'] = JSON.stringify(obj);
      }
      this.that.getData();
    },
    // 保存应用的过滤条件
    filterSaveClick(btn) {
      if (btn == 'update') {
        if (sessionStorage['filter']) {
          var plans = JSON.parse(JSON.parse(sessionStorage['filter']).plans);
          for (var plan of plans) {
            if (plan.value == 'onself') {
              this.$notify({
                title: '警告',
                message: '系统默认过滤器不支持修改',
                type: 'warning'
              });
              return;
            }
          }
        }
      }
      this.filterSaveShow = true;
      if (this.sessionFilters) {
        this.filterName = this.filter.name; //将原来过滤器的名字放入输入框
      }
    },
    // 取消应用的过滤器
    cancelFilter() {
      this.addFilterSearch = '';
      this.filterWords = '';
      if (this.sessionFilters) {
        //更新
        window.sessionStorage.removeItem('filter');
      } else {
        //保存
        window.sessionStorage.removeItem('preFilter');
      }
      this.sessionFilters = false; //将更新按钮改为保存按钮
      this.preFilter = []; //清空临时过滤器数组
      this.filterApplyShow = false; //隐藏预保留过滤器列表
      this.defaultFilterShow = true; //显示默认过滤列表
      this.that.getData();
      this.activeFilter = '';
      this.activeId = '';
    },
    // 保存过滤器
    filterSave() {
      var filterUser = this.filterUser;
      if (filterUser == 0) {
        filterUser = 'persion';
      } else if ((filterUser = 1)) {
        filterUser = 'public';
      } //一组过滤条件
      let params = {};
      params['type'] = filterUser; //私人,团队
      params['name'] = this.filterName; //过滤器名称
      params['plans'] = JSON.stringify(this.preFilter); //this.plans; //所有过滤条件json
      params['tablename'] = this.name; //表名
      if (this.sessionFilters) {
        //如果从session中获取了过滤条件,说明是已存在的过滤器,传过滤器id表示调用同一接口但是为更新
        params['_id'] = this.filter._id;
      }
      this.osg.ajax('queryPlan/upsert.do', params, res => {
        this.osg.toast('过滤器保存成功');
        this.getFilterList();
        this.preFilterChange = true;
        this.filterSaveShow = false;
        this.filterName = '';
        this.filterUser = 0;
      });
    },
    getParams(params, tablename) {
      tablename = tablename || this.name;
      //获取跳转传参session的过滤条件
      if (sessionStorage['filter'] && JSON.parse(sessionStorage['filter']).tablename == tablename) {
        //如果session有过滤条件,将条件放入已应用列表
        if (!$that.sessionFilters) {
          $that.sessionFilters = true; //只有第一次跳转过来加载页面会执行
          $that.filter = JSON.parse(sessionStorage['filter']);
          this.activeId = $that.filter._id;
          $that.preFilter = JSON.parse($that.filter.plans);
          //window.sessionStorage.removeItem('filters'); //清空session 每次getData都有影响
          $that.defaultFilterShow = false; //隐藏默认过滤列表
          $that.filterSearchShow = false; //隐藏过滤字段搜索列表
          $that.editFilterShow = false; //隐藏编辑过滤器列表
          $that.filterApplyShow = true; //显示预保留过滤器列表
        }
      }
      if (sessionStorage['preFilter'] && JSON.parse(sessionStorage['preFilter']).key == tablename) {
        if (!$that.sessionPreFilters) {
          $that.sessionPreFilters = true; //只有第一次跳转过来加载页面会执行
          $that.preFilter = JSON.parse(JSON.parse(sessionStorage['preFilter']).value);
          this.activeId = $that.preFilter._id;
          $that.defaultFilterShow = false; //隐藏默认过滤列表
          $that.filterSearchShow = false; //隐藏过滤字段搜索列表
          $that.editFilterShow = false; //隐藏编辑过滤器列表
          $that.filterApplyShow = true; //显示预保留过滤器列表
        }
      }

      for (var obj of $that.preFilter) {
        let type = 'string';
        // 部分下拉字段值 数据库字段类型是数字
        // TODO:数值类型特殊处理，之后根据字段配置
        let fieldArr = [
          'payState',
          'paystate',
          'productState',
          'auditstate',
          'auditStatus',
          'settleState',
          'settlePayState',
          'tradeIn',
          'count',
          'exts.agelimit',
          'state',
          'type',
          'unlockPayState',
          'orderType',
          'payType',
          'auditstate',
          'guaranteedTime',
          'partnerType',
          'refundStatus',
          'exts.npsScore',
          'forfeitState',
          'taskState',
          'exts.settleMark',
          'typeValue'
        ];
        if (
          (fieldArr.indexOf(obj.fieldName) != -1 &&
            (window.$this.name != 'company' || obj.fieldName == 'state') &&
            window.$this.name != 'goal' &&
            window.$this.name != 'serviceLevel') ||
          obj.type == 'number' ||
          (obj.field && obj.field.frontEndConfig && obj.field.frontEndConfig.number)
        ) {
          type = 'integer';
        }
        // TODO:质保卡库存
        if (
          window.$this.name == 'warrantyProduct' ||
          window.$this.name == 'warrantyProductInventory'
        ) {
          if (obj.fieldName == 'countryUse') {
            type = 'integer';
          }
          if (obj.fieldName == 'status') {
            type = 'integer';
          }
          if (obj.fieldName == 'exts.applyTime') {
            type = 'string';
          }
        }

        // TODO:渗漏部位数组存成了逗号拼接字符串
        if (obj.type == 'cascade' && obj.fieldName.indexOf('exts') != -1) {
          obj.value = obj.value || [];
          if (obj.fieldName == 'exts.leakagesite' && this.name == 'serviceAppointment') {
            // 工单渗漏部位
            params['all:exts.leakagesite_copy|array#and'] = obj.value.join();
          } else {
            if (obj.value.length == 1) {
              params[`regex:${obj.fieldName}|string#and`] = '"' + obj.value;
            } else {
              params[`regex:${obj.fieldName}|string#and`] = obj.value;
            }
          }

          continue;
        }

        if (obj.fieldName == 'maintainPart') {
          obj.value = obj.value || [];
          if (obj.value.length == 1) {
            params[`preregex:${obj.fieldName}|string#and`] = obj.value;
          } else {
            params[`regex:${obj.fieldName}|string#and`] = obj.value;
          }
          continue;
        }

        // 维修部位数组存成了逗号拼接字符串
        if (obj.fieldName == 'exts.repairParts') {
          obj.value = obj.value || [];
          if (obj.value.length == 1) {
            params[`preregex:${obj.fieldName}|${type}#and`] = obj.value.join();
          } else {
            params[`${obj.relation}:${obj.fieldName}|${type}#and`] = obj.value.join();
          }
          continue;
        }

        if (obj.type == 'date' || obj.type == 'datetime') {
          if (obj.type == 'date') {
            if (obj.value.indexOf(' ') != -1);
            obj.value = obj.value.split(' ')[0];
          }
          // TODO:retentionDate字段类型存成了String
          if (
            obj.fieldName == 'exts.retentionDate' ||
            obj.fieldName == 'exts.estimatedDeliveryDate' ||
            obj.fieldName == 'exts.visitDate'
          ) {
            obj.type = 'string';
          } else {
            if (obj.relation == 'gte') {
              type = 'date';
            } else if (obj.relation == 'lte') {
              type = 'datetime';
            }
          }
          // TODO:质保模块是日期
          if (window.location.href.indexOf('Warrantys') != -1) {
            if (obj.fieldName == 'startTime' || obj.fieldName == 'warrantyTime') {
              type = 'string';
            }
          }
          // TODO:财务审核、支付记录的支付时间是string
          if (
            window.location.href.indexOf('PaymentRecords') != -1 ||
            window.location.href.indexOf('FinancialAudit') != -1
          ) {
            if (obj.fieldName == 'payTime' || obj.fieldName == 'auditstate2Time') {
              type = 'string';
            }
          }
          //合同字段特殊处理
          if ($this.name == 'contract') {
            if (
              obj.fieldName == 'startDate' ||
              obj.fieldName == 'endDate' ||
              obj.fieldName == 'exts.npsCreateTime'
            )
              type = 'string';

            if (obj.fieldName == 'examinStatus') type = 'integer';
          }

          // TODO:质保卡库存
          if ($this.name == 'warrantyProductInventory') {
            if (obj.fieldName == 'exts.applyTime') {
              //预约时间
              type = 'string';
            }
          }
        }
        if (obj.type == 'area') {
          if (obj.value.length > 0) {
            params['is:province|string#and'] = obj.value[0];
          }
          if (obj.value.length > 1) {
            params['is:city|string#and'] = obj.value[1];
          }
          if (obj.value.length > 2) {
            params['is:district|string#and'] = obj.value[2];
          }
        } else if (obj.fieldName == 'orgId') {
          // 查询所属组织
          obj.value = obj.value || [];
          params['in:orgId|array#and'] = obj.value.toString();
        } else {
          params[`${obj.relation}:${obj.fieldName}|${type}#and`] = obj.value;
        }
      }
    },
    //列表指定过滤器
    //客户阶段：线索/商机
    lifecycleStage(smodule, typeName, type) {
      let filterObj = {
        type: 'public',
        tablename: smodule,
        name: '阶段',
        plans:
          '[{"note":"阶段 为 ' +
          typeName +
          '","type":"text","fieldName":"lifecycleStage","relation":"regex","value":"' +
          type +
          '"}]'
      };
      sessionStorage.removeItem('filter');
      sessionStorage.removeItem('preFilter');
      sessionStorage['filter'] = JSON.stringify(filterObj);
      $that.sessionFilters = false;
      this.activeFilter = type; //左侧筛选列表激活背景
      this.that.getData();
    },
    getOrgList() {
      this.osg.ajax('org/query.do', {}, res => {
        this.options.orgList = res.data.orgList;
      });
    },
    getOrgs() {
      this.osg.ajax('org/query.do', { _all: '1' }, res => {
        res.data.orgList.map(item => {
          item.label = item.orgName;
          item.value = item._id;
        });
        this.options.orgs = res.data.orgList;
      });
    },
    getOrgCheckedNodes() {
      let orgs = this.$refs.org.getCheckedNodes();
      this.orgNames = orgs.map(item => item.label || item.text).join('、');
      // console.log(orgs, this.orgNames);
    }
  },
  watch: {
    //监视添加过滤器搜索框
    addFilterSearch() {
      var addFilterList0 = this.addFilterList0;
      var addFilterList = [];
      var addFilterSearch = this.addFilterSearch;
      for (var list of addFilterList0) {
        if (list.nameDisp.indexOf(addFilterSearch) != -1) {
          addFilterList = addFilterList.concat(list);
        }
      }
      this.addFilterList = addFilterList;
    },
    //监视筛选词,变更触发筛选
    filterWords() {
      if (this.apply != 'apply') {
        //当点击添加过滤器时会清空filterWords,清空不触发watch,避免传空value

        let conditionName;
        for (var condition of this.options.conditions) {
          if (condition.value == this.isHas) {
            conditionName = condition.label;
            break;
          }
        }
        let valueLabel;
        if (this.selFilter.valueOption) {
          for (var item of this.options[this.selFilter.valueOption]) {
            if (item.value == this.filterWords) {
              valueLabel = item.label;
              break;
            }
          }
        } else {
          valueLabel = this.filterWords;
        }

        //拼接过滤条件中文名称
        var preFilterName = this.selFilter.nameDisp + ' ' + conditionName + ' ' + valueLabel;

        //放入到已应用过滤条件数组
        this.preFilter.push({
          note: preFilterName,
          type: this.selFilter.type,
          fieldName: this.selFilter.name,
          relation: this.isHas,
          value: this.filterWords,
          field: this.selFilter
        });
        // 查询第一页
        this.that.fpi = this.that.fpi || {};
        this.that.fpi.page = 1;
        this.that.getData(); //请求
        this.preFilter.pop(); //只有应用过滤器才最终保存到数组,所以请求后需要移除
      } else {
        this.apply = ''; //恢复watch
      }
    },
    //监视preFilter,有修改才能保存
    preFilter() {
      this.preFilterChange = false;
    },
    isHas() {
      if (!this.selFilter.isEdit) {
        if (this.selFilter.type == 'checkbox' || this.selFilter.multiple) {
          this.filterWords = [];
        } else {
          this.filterWords = '';
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import url('../resources/css/filters.css');
</style>
<style lang="scss">
#app .c-filter {
  font-size: 12px !important;
  display: flex;
  flex-direction: column;
  .el-collapse {
    border: none;
    font-size: 12px;
  }
  .el-collapse-item__header {
    font-size: 12px !important;
    height: 39px;
    padding: 0 10px !important;
    box-sizing: border-box;
  }
  .el-collapse-item__content {
    padding-bottom: 0px;
  }
  .filter-list-item {
    box-sizing: border-box;
    height: 49px;
    line-height: 49px;
    padding: 0 15px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px !important;
  }
  .filter-list-item.active {
    // color: #409eff;
    background: #e8f4f7; // #f2f2f2;
  }
  .filter-list-item:last-child {
    height: 48px;
    line-height: 48px;
  }
}
</style>
